import styled from "styled-components"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { CellLogo } from "components/EvtKit/list-items/CellLogo"
import { CellText } from "components/EvtKit/list-items/CellText"
import { CellSwitch } from "components/EvtKit/list-items/CellSwitch"
import { CellActionButtons } from "components/EvtKit/list-items/CellActionButtons"
import { formatPrice } from "utils/formatPrice"
import { useAppSelector } from "reducers/store"

const ListItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 16px;
  padding-right: 24px;
`

const ListItemsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.08);
`

const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

interface PlanListProps {
  onClickEdit: (item: App.IPurchasePlan) => void
  onClickSwitch: (item: App.IPurchasePlan) => void
}

const PurchasePlanList = (props: PlanListProps) => {
  const { onClickEdit, onClickSwitch } = props

  const { data, loading } = useAppSelector((state) => state.purchasePlan.purchasePlanList)

  return (
    <>
      <ListItemsContainer>
        {loading && <Spinner />}
        {!loading &&
          data.map((item, index) => (
            <ListItemsContent key={index}>
              <CellLogo title={item.name} />
              <CellText title="Chave do Plano" content={item.planKey} />
              <CellText title="Enterprise" content={item.isEnterprise ? "SIM" : "NÃO"} />
              <CellText title="Produto" content={item.product.prefixUrl} />
              <CellText title="Unidade" content={item.fromPriceUnit} />
              <CellText title="Preço" content={formatPrice(Number(item.fromPrice), "BRL")} />
              <CellSwitch initialState={item.isPublished} onClickSwitch={() => onClickSwitch(item)} />
              <ActionButtonsContainer>
                <CellActionButtons onClickEdit={() => onClickEdit(item)} />
              </ActionButtonsContainer>
            </ListItemsContent>
          ))}
      </ListItemsContainer>
    </>
  )
}

export default PurchasePlanList
